import {getParser, Parser} from 'bowser';
import {isClient} from './environment';

export const browserInfo: Parser.Parser | undefined = isClient
  ? getParser(window.navigator.userAgent)
  : undefined;

export const isBrowser = (browser: string): boolean => {
  if (!browserInfo) return false;

  return browserInfo.isBrowser(browser);
};
